import { APIURL } from '../constant/apiConstant'
import ApiService from './apiRequest'
import AsyncStorageFunc from '../utilities/asyncStorage';

export const getStatements_old = async (page) => {
  let deviceId = await AsyncStorageFunc.getData('deviceId');
  let token = await AsyncStorageFunc.getData("TOKEN");
  const header = {deviceModel: "", appVersion: "", platform: "", network: "", Authorization: token ? "bearer " + token : "",pageNo: page, deviceId: deviceId};
  return new Promise((resolve, reject) => {
    ApiService.getWithToken(APIURL.GET_STATEMENTS, {}, header)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => { reject(err);});
  });
};
export const downloadStatement = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DOWNLOAD_STMT, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
};
export const downloadStatementHistoryExcel = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DOWNLOAD_STMT_HISTORY_EXCEL, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
};
export const downloadStatementHistory = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.DOWNLOAD_STMT_HISTORY, params)
      .then(res => {
        resolve(res);
      }).catch(err => { reject(err); });
  });
};
export const getStatementDownLoadStatus = async (params) => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.GET_STATEMENTS_DOWNLOAD_STATUS, params)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => { reject(err);});
  });
};

export const getStatements = params => {
  return new Promise((resolve, reject) => {
    ApiService.postwithtoken(APIURL.STATEMENT_FILTER, params)
      .then(res => {
        resolve(res?.data || []);
      }).catch(err => {  reject(err);});
  });
};

